import axios from '@/axios'
import Vue from 'vue'

const state = {
  rewards: [],
  order: null,
  digitalOrder: null,
  variantsOrder: null,
  digitalOrderModalId: null,
  materialOrderModalId: null,
  variantsOrderModalId: null,
  delayDigitalOrderModal: false,
};

const actions = {
  fetchRewards({commit}, config) {
    return axios.get('rewards', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_REWARDS', r.data.rewards)
        }
      })
  },
  setOrder({commit}, payload) {
    commit('SET_ORDER', payload)
  },
  clearOrder({commit}) {
    commit('CLEAR_ORDER')
  },
  setDigitalOrder({commit}, payload) {
    commit('SET_DIGITAL_ORDER', payload)
  },
  setVariantsOrder({commit}, payload) {
    commit('SET_VARIANTS_ORDER', payload)
  },
  clearDigitalOrder({commit}) {
    commit('CLEAR_DIGITAL_ORDER')
  },
  setDigitalOrderModalId({commit}, payload) {
    commit('SET_DIGITAL_ORDER_MODAL_ID', payload)
  },
  clearDigitalOrderModalId({commit}) {
    commit('CLEAR_DIGITAL_ORDER_MODAL_ID')
  },
  setMaterialOrderModalId({commit}, payload) {
    commit('SET_MATERIAL_ORDER_MODAL_ID', payload)
  },
  clearMaterialOrderModalId({commit}) {
    commit('CLEAR_MATERIAL_ORDER_MODAL_ID')
  },
  setVariantsOrderModalId({commit}, payload) {
    commit('SET_VARIANTS_ORDER_MODAL_ID', payload)
  },
  clearVariantsOrderModalId({commit}) {
    commit('CLEAR_VARIANTS_ORDER_MODAL_ID')
  },
  clearVariantsOrder({commit}) {
    commit('CLEAR_VARIANTS_ORDER')
  },
  setDelayDigitalRewardModal({commit}, value) {
    commit('SET_DELAY_DIGITAL_ORDER_MODAL', value)
  }
};

const mutations = {
  SAVE_REWARDS(state, rewards) {
    Vue.set(state, 'rewards', rewards)
  },
  SET_ORDER(state, order) {
    Vue.set(state, 'order', order)
  },
  SET_DIGITAL_ORDER(state, order) {
    Vue.set(state, 'digitalOrder', order)
  },
  SET_VARIANTS_ORDER(state, order) {
    Vue.set(state, 'variantsOrder', order)
  },
  CLEAR_ORDER(state) {
    Vue.set(state, 'order', null)
  },
  CLEAR_DIGITAL_ORDER(state) {
    Vue.set(state, 'digitalOrder', null)
  },
  CLEAR_VARIANTS_ORDER(state) {
    Vue.set(state, 'variantsOrder', null)
  },
  SET_DIGITAL_ORDER_MODAL_ID(state, orderId) {
    state.digitalOrderModalId = orderId;
  },
  CLEAR_DIGITAL_ORDER_MODAL_ID(state) {
    Vue.set(state, 'digitalOrderModalId', null)
    Vue.set(state, 'delayDigitalOrderModal', false)
  },
  SET_MATERIAL_ORDER_MODAL_ID(state, orderId) {
    state.materialOrderModalId = orderId;
  },
  SET_VARIANTS_ORDER_MODAL_ID(state, orderId) {
    state.variantsOrderModalId = orderId;
  },
  CLEAR_MATERIAL_ORDER_MODAL_ID(state) {
    Vue.set(state, 'materialOrderModalId', null)
  },
  CLEAR_VARIANTS_ORDER_MODAL_ID(state) {
    Vue.set(state, 'variantsOrderModalId', null)
  },
  SET_DELAY_DIGITAL_ORDER_MODAL(state, value) {
    state.delayDigitalOrderModal = value;
  }
};

const getters = {
  getRewardOrderById:
    state => (id) => state.rewards.find(order => order.id === id)
};

export default {
  state,
  actions,
  mutations,
  getters,
}
